import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom'; 
import { jwtDecode } from 'jwt-decode';
import { enqueueSnackbar } from 'notistack';
import { Box, Button, Typography, CircularProgress } from '@mui/material';

const ShowForms = () => {
  const [forms, setForms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const token = localStorage.getItem('token');
  const { role } = jwtDecode(token);
  
  useEffect(() => {
    const fetchForms = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/forms/form/${role}`);
        setForms(response.data);
        setLoading(false);
      } catch (err) {
        setError('Failed to load forms');
        setLoading(false);
        enqueueSnackbar('Failed to load forms', { variant: 'error' });
      }
    };

    fetchForms();
  }, [role]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return <Typography color="error">{error}</Typography>;
  }

  return (
    <Box sx={{ maxWidth: 600, mx: 'auto', p: 2 }}>
      {forms.length === 0 ? (
        <Typography>No forms available for this user.</Typography>
      ) : (
        <Box display="flex" flexDirection="column" gap={2}>
          {forms.map((form) => (
            <Button
              component={Link}
              to={`${form._id}`}
              key={form._id}
              variant="contained"
              color="primary"
              sx={{ textTransform: 'none' }}
            >
              {form.title}
            </Button>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default ShowForms;
